<template>
  <dialogModule
    top="8"
    width="580px"
    title="优惠券核销"
    v-if="ticketVisible"
    :dialogVisible="ticketVisible"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @close="close">
    <span slot="close" class="el-icon-close cursor" @click="close"></span>
    <div slot="content">
      <section class="check-box" v-if="contentType === '1'">
        <div class="channel-box row align-center space-center">
          <div class="item" :class="[channelType === '1' ? 'check-item' : '']" @click="changeChannel('1')">
            <img src="@/assets/images/douyin.png">
            <div>抖音核销</div>
            <div class="check-label" v-if="channelType === '1'">
              <p></p>
              <i class="iconfont icon-gou"></i>
            </div>
          </div>
          <div class="item" :class="[channelType === '2' ? 'check-item' : '']" @click="changeChannel('2')">
            <img src="@/assets/images/kuaishou.png">
            <div>快手核销</div>
            <div class="check-label" v-if="channelType === '2'">
              <p></p>
              <i class="iconfont icon-gou"></i>
            </div>
          </div>
          <div v-if="pinkerVisible === '1'" class="item" :class="[channelType === '3' ? 'check-item' : '']" @click="changeChannel('3')">
            <img src="@/assets/images/wxchat.png">
            <div>微信卡券</div>
            <div class="check-label" v-if="channelType === '3'">
              <p></p>
              <i class="iconfont icon-gou"></i>
            </div>
          </div>
        </div>
        <div class="text-tip">当前验券渠道为：<span>{{channelType === '1' ? '抖音核销' : channelType === '2' ? '快手核销' : '微信卡券'}}</span>。请扫描顾客的优惠券码</div>
        <div class="row align-center space-between row-value">
          <input type="text" ref="coupon" v-model="certificateCode" :disabled="checkLoading" @blur="submitTicket" @keyup.enter="$event.target.blur()" />
          <span class="iconfont icon-saoma"></span>
        </div>
        <el-button class="sure-btn" @click="submitTicket" :loading="checkLoading">确认提交券码</el-button>
      </section>
      <section class="reprice-deduction" v-if="codeTicketList.length && contentType === '2'">
        <div class="use-tips" v-if="codeTicketList.length > 1">该券码有{{codeTicketList.length}}种核销方式，请选择1种进行核销。</div>
        <div style="height: 65vh;overflow: auto">
          <div class="ticket-data" v-for="(item, i) in codeTicketList" :key="i" @click="changeCheck(item)">
            <div class="row align-center space-between">
              <div class="row align-center">
                来源：
                <img class="source-img" v-if="item.channel === '1'" src="@/assets/images/douyin.png" />
                <img class="source-img" v-if="item.channel === '2'" src="@/assets/images/kuaishou.png" />
                <img class="source-img" v-if="item.channel === '3'" src="@/assets/images/wxchat.png" />
                {{item.channelName}}
              </div>
              <div>类型：<span class="type">{{item.couponTypeName}}</span></div>
            </div>
            <div class="title">{{item.name}}</div>
            <div class="desc">{{item.couponRemark}}</div>
            <div class="time">有效期：{{item.startTime}} 至 {{item.expireTime}}</div>
            <template v-if="codeTicketList.length > 1">
            <div class="reason" v-if="item.noUseMessage">不可用原因：{{item.noUseMessage}}</div>
            <div class="check-coupon" :class="[item.selectState ? 'check' : item.noUseMessage ? 'disable' : '']">
              <i v-if="item.selectState" class="iconfont icon-gou"></i>
            </div>
            </template>
          </div>
        </div>
        <div class="ticket-action row align-center space-center">
          <el-button v-if="!checkObject" class="rescan" :loading="checkLoading" @click="reScan">重扫券码</el-button>
          <el-button class="sure-use" :loading="checkLoading" @click="sureUse">{{codeTicketList.length > 1 ? '确认选择该核销方式' : '确认核销'}}</el-button>
        </div>
      </section>
    </div>
  </dialogModule>
</template>

<script>
import dialogModule from "@/components/dialogModule.vue"
import {operateGoodsNo} from "@/libs/http/modules/posOrder"
export default {
  components: {
    dialogModule
  },
  props: {
    goodsList: {//收银台货品列表
      type: Array,
      default: () => []
    },
    couponList: {//优惠券列表
      type: Array,
      default: () => []
    },
    activityInfos: {//匹配到的促销
      type: Array,
      default: () => []
    },
    checkActivityInfos: {//选中的促销
      type: Array,
      default: () => []
    },
    checkObject: {//核销对象，重选核销类型时才有值
      type: Object,
      default: () => null
    },
    pinkerVisible: {//是否显示品氪核销渠道
      type: String,
      default: ''
    },
    vipData: {//会员信息
      type: Object,
      default: () => null
    }
  },
  data() {
    return{
      ticketVisible: true,
      channelType: '1',
      contentType: '1',
      certificateCode: '',
      checkLoading: false,
      giveVisible: false,
      couponInfoList: [],
      codeTicketList: [],
      crmPhone: '',
      hasPinker: false
    }
  },
  created() {
    if(this.couponList.length){
      this.couponInfoList = [...this.couponList]
      this.hasPinker = this.couponList.some(item=>{
        return item.channel === '3'
      })
    }
    if(this.checkObject){
      this.contentType = '2'
      let obj = {
        alterGoodsWay: '3',
        operationCouponType: '3',
        certificateId: this.checkObject.certificateId
      }
      this.actionTicket('check', obj)
    }
    if(this.contentType === '1' && !this.checkObject){
      this.$nextTick(() => {
        this.$refs.coupon.focus()
      })
    }
  },
  methods: {
    close(){
      if(this.checkLoading) return //接口未响应时不允许点"x"关闭弹窗
      if(this.contentType === '2'){
        if(this.checkObject){
          this.ticketVisible = false
          this.$emit('close')
        }else{
          let obj = {
            operationCouponType: '5',
            certificateId: this.codeTicketList[0].certificateId
          }
          this.actionTicket('close', obj)
        }
      }else{
        this.ticketVisible = false
        this.$emit('close')
      }
    },
    changeChannel(type){
      if(type === this.channelType) return
      this.channelType = type
      this.$nextTick(() => {
        this.$refs.coupon.focus()
      })
    },
    changeCheck(item){
      if(item.noUseMessage) return
      this.codeTicketList.forEach(ticket => {
        ticket.selectState = false
      })
      item.selectState = !item.selectState
    },
    actionTicket(type, operateObj){
      this.checkLoading = true
      let params = {
        type: '6',
        operateCouponsGoodInfo: operateObj
      }
      if (this.goodsList.length) {
        params['goodInfos'] = this.goodsList
      }
      if(this.couponInfoList.length || this.codeTicketList.length){
        let list = []
        if(this.codeTicketList.length === 1) {
          list = [...this.couponInfoList, ...this.codeTicketList]
        }else{
          let checkList = this.codeTicketList.filter(item=>{
            return item.selectState
          })
          list = [...this.couponInfoList, ...checkList]
        }
        params['couponInfoList'] = list
      }
      if(this.activityInfos.length){
        params['activityInfos'] = this.activityInfos
      }
      if(this.checkActivityInfos.length){
        params['checkActivityInfos'] = this.checkActivityInfos
      }
      operateGoodsNo(params).then(res=>{
        this.checkLoading = false
        if(type === 'check'){
          if(!this.checkObject && this.channelType === '3' && this.vipData && this.vipData.phone && this.vipData.phone !== res.crmPhone){
            this.certificateCode = ''
            let errorTxt = this.hasPinker ? '会员不一致，请先撤销品氪优惠券' : '会员不一致，请先取消选择会员'
            return this.$message({showClose: true, message: errorTxt, type: "error", duration: 2000})
          }
          if(res.crmPhone){
            this.crmPhone = res.crmPhone
          }else{
            this.crmPhone = ''
          }
          if(res.couponGoodInfos){
            this.codeTicketList = res.couponGoodInfos.filter(item=>{
              if(this.checkObject){
                return item.certificateId === operateObj.certificateId
              }else{
                return item.certificateCode === operateObj.certificateCode
              }
            })
            if(this.codeTicketList.length === 1){
              if([0, 3].includes(this.codeTicketList[0].couponType)){
                this.contentType = '2'
              }else{
                this.ticketVisible = false
                this.$emit('close')
                this.$emit('open', this.codeTicketList[0])
              }
            }else{
              this.codeTicketList.forEach(item=>{
                this.$set(item, 'selectState', false)
              })
              let index = ''
              if(this.checkObject){
                index = this.codeTicketList.findIndex(item=>{
                  return item.couponInfoId === this.checkObject.couponInfoId && item.certificateId === this.checkObject.certificateId
                })
              }else{
                index = this.codeTicketList.findIndex(item=>{
                  return !item.noUseMessage
                })
              }
              if(index !== -1){
                this.codeTicketList[index].selectState = true
              }
              this.contentType = '2'
            }
          }
        }else if(type === 'rescan'){
          this.contentType = '1'
          this.certificateCode = ''
          this.codeTicketList = []
          this.$nextTick(() => {
            this.$refs.coupon.focus()
          })
        }else if(type === 'close'){
          this.ticketVisible = false
          this.$emit('close')
        }else{
          this.ticketVisible = false
          this.$emit('close')

          // 取到当前操作的券最新信息传到首页
          let currentObj = null
          if(this.checkObject){
            currentObj = res.couponGoodInfos.find(item=>{
              return item.certificateId === this.codeTicketList[0].certificateId
            })
          }else{
            currentObj = res.couponGoodInfos.length === 1 ? res.couponGoodInfos[0] : res.couponGoodInfos[res.couponGoodInfos.length - 1]
          }
          this.$emit('open', currentObj, res)
        }
      }).catch(error=>{
        if(type === 'check' && !this.checkObject){
          this.certificateCode = ''
          this.$nextTick(() => {
            this.$refs.coupon.focus()
          })
        }
        this.checkLoading = false
        this.$message({showClose: true, message: error, type: "error", duration: 2000})
      })
    },
    submitTicket(){
      const scanCode = this.certificateCode.trim()
      if(!scanCode){
        return this.$nextTick(() => {
          this.$refs.coupon.focus()
        })
      }
      let obj = {
        operationCouponType: '3',
        certificateCode: scanCode,
        couponChannelType: this.channelType
      }
      this.actionTicket('check', obj)
    },
    reScan(){
      let obj = {
        operationCouponType: '5',
        certificateId: this.codeTicketList[0].certificateId
      }
      this.actionTicket('rescan', obj)
    },
    sureUse(){
      if(this.codeTicketList.length > 1){
        let result = this.codeTicketList.every(item=>{
          return !item.selectState
        })
        if(result){
          return this.$message({showClose: true, message: "请选择1种进行核销", type: "error", duration: 2000})
        }
        let couponObj = this.codeTicketList.find(item=>{
          return item.selectState
        })
        if([1, 2].includes(couponObj.couponType)){
          if(!this.checkObject){
            this.ticketVisible = false
            this.$emit('close')
          }
          this.$emit('open', couponObj, this.checkObject ? 'chooseType' : 'normal')//增加返回是否重选核销类型参数
        }else{
          let obj = {
            operationCouponType: '4',
            certificateId: this.codeTicketList[0].certificateId
          }
          if(this.checkObject){
            obj['alterGoodsWay'] = '3'
            obj['index'] = this.checkObject.couponIndex
          }
          this.actionTicket('sure', obj)
        }
      }else{
        let obj = {
          operationCouponType: '4',
          certificateId: this.codeTicketList[0].certificateId
        }
        this.actionTicket('sure', obj)
      }
      if(this.channelType === '3' && this.crmPhone){
        this.$emit('queryVip', this.crmPhone)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.check-box{
  text-align: center;
  .channel-box{
    margin: 30px auto 40px;
    .item{
      color: #000;
      width: 110px;
      height: 110px;
      cursor: pointer;
      overflow: hidden;
      margin-right: 15px;
      border-radius: 6px;
      position: relative;
      border: 2px solid #eee;
      img{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin: 18px auto 10px;
      }
      &:last-child{
        margin-right: 0;
      }
      .check-label{
        p{
          width: 50px;
          height: 50px;
          right: -25px;
          bottom: -25px;
          position: absolute;
          background: #067cf2;
          transform: rotate(45deg);
        }
        i{
          right: 2px;
          bottom: 2px;
          color: #fff;
          font-size: 14px;
          position: absolute;
        }
      }
    }
    .check-item{
      background: #f1f5ff;
      border-color: #067cf2;
    }
  }
  .text-tip {
    color: #000;
    font-size: 18px;
    margin: 20px 0 30px;
    span{
      color: #067cf2;
      font-weight: bold;
    }
  }
  .row-value {
    width: 375px;
    height: 40px;
    margin: auto;
    padding: 0 10px;
    background: #F3F5FA;
    input {
      width: 100%;
      border: none;
      outline: none;
      background: none;
      line-height: 38px;
    }
    span {
      color: #067CF2;
      font-size: 20px;
      font-weight: bold;
      margin-left: 10px;
    }
  }
  .sure-btn {
    color: #fff;
    width: 250px;
    margin: 20px 0;
    font-size: 18px;
    border-radius: 4px;
    text-align: center;
    background: #067CF2;
  }
}

.reprice-deduction{
  color: #000;
  font-size: 14px;
  margin: 10px 20px;
  .use-tips{
    color: #000;
    margin: 15px 0;
    font-size: 16px;
    font-weight: bold;
  }
  .ticket-data{
    padding: 15px;
    cursor: pointer;
    border-radius: 4px;
    position: relative;
    margin-bottom: 20px;
    background: #F5F7FA;
    .source-img{
      width: 14px;
      margin-right: 5px;
      border-radius: 4px;
    }
    .type{
      color: #722ED1;
      font-size: 18px;
      padding: 2px 5px;
      border-radius: 2px;
      font-weight: bolder;
    }
    .title{
      font-size: 17px;
      font-weight: bold;
      line-height: 22px;
      margin: 15px 0 20px;
    }
    .desc{
      width: 90%;
      color: #333;
      font-weight: bold;
      margin-bottom: 20px;
      white-space: pre-line;
    }
    .time{
      color: #666;
    }
    .reason{
      color: #F8475F;
      margin-top: 15px;
    }
    .check-coupon{
      position: absolute;
      right: 4px;
      width: 25px;
      height: 25px;
      top: 50%;
      border-radius: 2px;
      border: 1px solid #999;
      transform: translate(-50%, -50%);
      display: flex;
      align-items: center;
      justify-content: center;
      i{
        color: #fff;
        font-size: 16px;
      }
    }
    .check{
      background: #067cf2;
      border-color: #067cf2;
    }
    .disable{
      background: #e9e9e9;
    }
  }
  .ticket-action{
    margin-top: 30px;
    padding-bottom: 20px;
    .rescan{
      color: #000;
      cursor: pointer;
      text-align: center;
      border-radius: 4px;
      border: 1px solid #ddd;
    }
    .sure-use{
      color: #fff;
      width: 200px;
      cursor: pointer;
      font-size: 16px;
      margin-left: 40px;
      border-radius: 4px;
      text-align: center;
      background: #067CF2;
    }
  }
}
</style>